import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, filter, distinctUntilChanged, take} from 'rxjs/operators';
import { GEO_TARGETING_LOCATION_TYPE_KEY, GeoLocationTypeState, LocationType } from './geo-location-type.reducer';
import { GEO_TARGETING_STATE_KEY, GeoState } from '../geo.reducer';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers/index';
import { GeoLocationTypeActions } from './geo-location-type.actions';
import { GeoIdService } from '../geo.id';
import { LocationTypeValue } from '../geo.interface';

@Injectable()
export class GeoLocationTypeService {

  $model;

  getModel = (_store: Store<AppState>): Observable<GeoLocationTypeState> => {
    return _store.select(GEO_TARGETING_STATE_KEY)
                 .pipe(
                   map((geo) => {
                     const id = this.geoIdService.id$.getValue();
                     return geo[id];
                   }),
                   filter((geoState: GeoState) => Boolean(geoState)),
                   map((geoState: GeoState) => {
                     return geoState[GEO_TARGETING_LOCATION_TYPE_KEY];
                   }),
                   distinctUntilChanged()
                 );
  }

  setTranslatedTypes () {
    this._store.dispatch(this.geoLocationTypeActions.setTranslatedTypes());
  }

  selectType (selectedType: LocationType) {
    this._store.dispatch(this.geoLocationTypeActions.selectType(selectedType));
  }

  selectTypeByValue (selectedTypeValue: LocationTypeValue[]) {
    this.$model
        .pipe(
          take(1)
        )
        .subscribe((model) => {
          const selectedType = model.types.find((type) => type.value.toString() === selectedTypeValue.toString());
          this._store.dispatch(this.geoLocationTypeActions.selectType(selectedType));
        });
  }

  showInfoForType (type: LocationType) {
    this._store.dispatch(this.geoLocationTypeActions.showInfoForType(type));
  }

  toggleTypeDropdown (isOpen?: boolean) {
    this._store.dispatch(this.geoLocationTypeActions.toggleTypeDropdown(isOpen));
  }

  constructor (private _store: Store<AppState>,
               private geoIdService: GeoIdService,
               private geoLocationTypeActions: GeoLocationTypeActions) {
    this.$model = this._store.pipe(this.getModel);
  }
}
